import * as React from "react";

import { cn } from "@/lib/utils";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { ContactForm } from "@/components/ui/contact/contactForm";

export interface ContactCardProps extends Omit<React.ComponentProps<"div">, "onError"> {
  onSuccess?: () => void;
  onError?: (message: string) => void;
  /** true のとき送信成功時に window.gtagSendEvent(redirectUrl) を呼ぶ（MBSC リードフォーム用）。手動で gtagSendEvent スクリプトを埋め込むこと。 */
  sendLeadFormConversion?: boolean;
  /** sendLeadFormConversion 時に遷移させる URL。未指定なら遷移しない。 */
  leadFormConversionRedirectUrl?: string;
}

function ContactCard({
  className,
  onSuccess,
  onError,
  sendLeadFormConversion,
  leadFormConversionRedirectUrl,
  ...props
}: ContactCardProps) {
  const handleSuccess = React.useCallback(() => {
    onSuccess?.();
    if (sendLeadFormConversion && typeof window !== "undefined" && typeof window.gtagSendEvent === "function") {
      window.gtagSendEvent(leadFormConversionRedirectUrl);
    }
  }, [onSuccess, sendLeadFormConversion, leadFormConversionRedirectUrl]);

  return (
    <Card
      data-slot="contact-card"
      className={cn(
        "overflow-hidden border-border/50 bg-card/50 shadow-none transition-colors hover:bg-card/80",
        "py-6 sm:py-8",
        "pb-[max(1.5rem,env(safe-area-inset-bottom))] sm:pb-0",
        className,
      )}
      {...props}
    >
      <CardHeader className="space-y-2 px-5 pb-3 sm:space-y-3 sm:px-8 sm:pb-4">
        <p className="font-mono text-[11px] font-medium uppercase tracking-[0.2em] text-muted-foreground">
          無料相談
        </p>
        <h3 className="font-serif text-xl font-light leading-snug tracking-tight text-foreground sm:text-2xl md:text-3xl">
          まずは貴社の課題をお聞かせください
        </h3>
        <p className="max-w-md text-sm leading-relaxed text-muted-foreground">
          課題のヒアリングからお見積りまで、無料で承ります。ステーブルコインの導入・活用でお悩みなら、専門家が丁寧に伴走いたします。
        </p>
      </CardHeader>
      <CardContent className="px-5 sm:px-8">
        <ContactForm onSuccess={handleSuccess} onError={onError} />
      </CardContent>
    </Card>
  );
}

export { ContactCard };
